<script>
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'

export default {
    props: {
        inputValue: {
            type: String,
            default: '',
        },
        disable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            // valueとlabelの値は同値にするか
            colors: [
                {
                    value: BC.COMMON.LED_COLOR.YELLOW,
                    label: BC_TRANS_JP.COMMON.LED_COLOR.YELLOW,
                },
                {
                    value: BC.COMMON.LED_COLOR.PURPLE,
                    label: BC_TRANS_JP.COMMON.LED_COLOR.PURPLE,
                },
                {
                    value: BC.COMMON.LED_COLOR.BLUE,
                    label: BC_TRANS_JP.COMMON.LED_COLOR.BLUE,
                },
                {
                    value: BC.COMMON.LED_COLOR.LIGHT_BLUE,
                    label: BC_TRANS_JP.COMMON.LED_COLOR.LIGHT_BLUE,
                },
                {
                    value: BC.COMMON.LED_COLOR.RED,
                    label: BC_TRANS_JP.COMMON.LED_COLOR.RED,
                },
                {
                    value: BC.COMMON.LED_COLOR.GREEN,
                    label: BC_TRANS_JP.COMMON.LED_COLOR.GREEN,
                },
                {
                    value: BC.COMMON.LED_COLOR.WHITE,
                    label: BC_TRANS_JP.COMMON.LED_COLOR.WHITE,
                },
            ],
            value: this.inputValue
        }
    },

    watch: {
        inputValue(val) {
            this.value = val
        },
        value(val) {
            this.$emit('update:inputValue', val)
        }
    }
}
</script>

<template>
  <el-select v-model="value" :disabled="disable" class="color-select" placeholder="色を選択">
    <template #prefix>
      <div v-if="value" class="color-box" :style="{ background: value }"></div>
    </template>
    <el-option v-for="color in colors" :key="color.value" :label="color.label" :value="color.value">
      <div class="flex items-center">
        <div class="color-box" :style="{ background: color.value }"></div>
        <span>{{ color.label }}</span>
      </div>
    </el-option>
  </el-select>
</template>

<style scoped>
.color-select {
  width: 150px;
}

.color-select >>> .el-input__prefix {
  display: flex;
  align-items: center;
}

.color-box {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
  border: 1px solid #bbb;
  border-radius: 3px;
}
</style>
